import {Injectable, Optional} from '@angular/core';
import {merge} from 'lodash';

export class RpControlsConfig {}


export class RpControlsSettingsService {
  themes = ['default', 'app'];

  colors = {
    primary: '#666',
    error: 'red',
    accent: '', // TODO Implement
  };

  errors = {
    required: 'required',
    minlength: 'minimum length',
    maxlength: 'maxmimum length',
  };

  dropdown = {
    opacity: .4,
  };

  constructor( private config: RpControlsConfig) {
    if (config) merge(this, config); // Merges customizations onto class props
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: RpControlsConfig, decorators: [{ type: Optional }, ]},
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
